import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {Anchor, Icon, Text} from '@albert-io/atomic';
import {renderTimeFromNow} from 'lib/timeUtils';

import './author-dashboard-activity.scss';

const BoldedText = ({children}) => {
  return <span className='author-feedback-item__description--bold'>{children}</span>;
};

const AuthorFeedbackItem = ({feedback}) => {
  const questionUrl = {
    pathname: `queue/${feedback.setId}/${feedback.questionId}`
  };
  return (
    <div>
      <div className='author-feedback-item__wrapper'>
        <div className='author-feedback-item__header-container'>
          <Icon icon='comment' iconStyle='light' className='u-mar-r_2' />
          <div className='author-feedback-item__header'>
            <div>
              <div className='author-feedback-item__prompt'>
                <Anchor
                  href={questionUrl.pathname}
                  target='_blank'
                  as='a'
                  className='author-feedback-item__prompt u-mar-b_1'
                >
                  {feedback.title}
                </Anchor>
              </div>
              <Text emphasis='lowest' size='s' as='div'>
                {feedback.subject}
              </Text>
            </div>
            <Text emphasis='lowest' size='s' className='author-feedback-item__time-stamp' as='div'>
              {renderTimeFromNow(feedback.updatedAt)}
            </Text>
          </div>
        </div>
      </div>
      <Text emphasis='medium' size='m' as='div' className='u-mar-t_3 author-feedback-item__message'>
        <BoldedText>{feedback.user}</BoldedText> commented{' '}
        <BoldedText>
          {`"`}
          {feedback.message}
          {`"`}
        </BoldedText>
      </Text>
    </div>
  );
};

AuthorFeedbackItem.propTypes = {
  feedback: PropTypes.shape({
    feedbackId: PropTypes.string,
    message: PropTypes.string,
    questionId: PropTypes.string,
    setId: PropTypes.string,
    subject: PropTypes.string,
    time: PropTypes.instanceOf(moment),
    title: PropTypes.string,
    type: PropTypes.string,
    updatedAt: PropTypes.instanceOf(moment),
    updatedAtDisplay: PropTypes.string,
    user: PropTypes.string
  })
};

export default AuthorFeedbackItem;
